<template>
	<div>
	  <mu-appbar style="width: 100%;" color="#2196f3" >  
			 <mu-button icon slot="left"  @click="goback">
               <mu-icon  value="arrow_back"></mu-icon>
         </mu-button>
         <mu-button icon slot="right"  @click="refresh">
               <mu-icon  value="refresh"></mu-icon>
         </mu-button>
			交易记录
      </mu-appbar>
      
      <mu-paper >
      	  <div class="recordclass" v-for="item in datalist" :key="item.time">
                <div class='hbox flex-layout'>
                   <div>类型:{{item.c1=='cny'?'买入':'卖出'}} {{item.c1=='cny'?item.c2:item.c1|upper}}</div>
                   <div>交易数量:{{item.c1=='cny'?item.tvalue:item.cvalue|to8}}</div>
                </div>
                <div class='hbox flex-layout'>
                     <div>交易价格:{{item.price|to8}} {{item.c1=='cny'?item.c1:item.c2 | upper }}</div>
                      <div>交易总额:{{item.c1=='cny'?item.tvalue*item.price:item.cvalue*item.price|to8}} {{item.c1=='cny'?item.c1:item.c2 | upper }}</div>
                </div>
                
               <div class='hbox flex-layout'>
                     <div>交易时间:{{item.time}}</div>
                     <div>目标:{{item.c2 | upper }}</div>
               </div>
              
      	  </div>
      </mu-paper>
    </div>

</template>
<script type="text/javascript">
  import Api from '@/api'
	export default {
     
     created(){
       this.refresh();
     },
		 data(){
           return {
           
           	datalist:[
           	 
           	]
           }
          },
          filters: {
            to8(num){
             return Math.round(num).toFixed(2)
           },
             upper(v){
               return v.toUpperCase()
             }
          },

         methods:{
           
          refresh()
          {
                Api.transactions().then((res)=>{
          this.datalist=res.data;
         
        })
          },
         	goback(){
         		this.$router.go(-1);
         	}
         }
	}
</script>
<style scoped>
  
 .mu-table  td {
    padding: 0;
    text-align: center;
    width:25%;
  }
  .mu-table th {
     padding: 0;
    text-align: center;
  }
  .recordclass {
      color:black;
      display: flex;
      padding: 10px;
      flex-direction: column;
      align-items: flex-start;
      border-bottom: #cccccc 1px solid;
  }
  .flex-layout {
      justify-content: space-between;
      width: 100%;
  }
  
</style>



// WEBPACK FOOTER //
// src/pages/Transactions.vue